<template>
  <ArtworkAlert class="artwork-error" :class="{ 'artwork-error--compact': showStepsUI }">
    <div v-if="widthError || heightError">
      <b>The artwork must be {{ errorDimension }}.</b>
      <br />
      Please take a look at our
      <a :href="dpiInstructionsUrl" class="artwork-dimensions__link-to-dtf-artwork">
        Artwork DPI guide
      </a>
      for more info.
    </div>
    <div v-else-if="upscaleThresholdError">
      The uploaded image will not print clearly at this size. Reduce your image size, or click
      <a :href="dpiInstructionsUrl" target="_blank" class="artwork-dimensions__error-message-link">
        here
      </a>
      to learn how you can fix this.
    </div>
    <div v-else>
      <p class="artwork-error__generic-error-message" v-html="dimensionErrorMessage" />
    </div>
  </ArtworkAlert>
</template>

<script>
import { mapState } from "pinia";
import ArtworkAlert from "components/jiffy/vue-product-details-dtf/ArtworkAlert.vue";
import { useDtfStore } from "./store";

export default {
  name: "ArtworkError",
  components: { ArtworkAlert },
  props: {
    artwork: {
      type: Object,
      default: null
    },
    currentStore: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(useDtfStore, ["dpiInstructionsUrl", "gangSheetArtworkProductLink", "showStepsUI"]),
    validationError() {
      return this.artwork.errorMessage;
    },
    heightError() {
      return this.validationError === "gang_sheet_height_error";
    },
    widthError() {
      return this.validationError === "gang_sheet_width_error";
    },
    dimensionErrorMessage() {
      if (this.artwork.retryFailed) return "Image upload failed";

      return this.validationError || this.artwork.uploadError;
    },
    upscaleThresholdError() {
      return this.validationError === "upscale_threshold_exceeded";
    },
    errorDimension() {
      if (this.heightError) {
        return "7200px tall (24″ at 300 DPI)";
      }

      return "6600px wide (22″ at 300 DPI)";
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.artwork-error {
  margin: 16px 0;

  &--compact {
    margin-bottom: 0;
  }

  &__generic-error-message {
    margin: 0;
  }
}
</style>
